import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import AllAnswerPopup from "./AllAnswerPopup";

function QuestionsList({
    question,
    label,
    teacherComment,
    checkedOptions,
    setCheckedOptions,
    setShowCorrectAnswer,
    showCorrectAnswer,
    setIsAnswered,
    isAnswered,
}) {

    const [selectedOptions, setSelectedOptions] = useState({}); // user choice
    const [isCorrectAnswer, setIsCorrectAnswer] = useState(false);
    const userAnswerKey = question?.answer?.key;
    const correctAnswerKey = question?.correct_answers[0]?.option_key;

    const handleCheckboxChange = (question, opt) => {
        setCheckedOptions(true);
        setSelectedOptions((prev) => ({
            ...prev,
            [question.id]: opt.key, // only update current question
        }));

        const correct_answers = question.correct_answers.some((item) => item.option_key === opt.key);
        if (!correct_answers) {
            setShowCorrectAnswer(true)
        } else {
            setShowCorrectAnswer(false)
            setIsAnswered(correct_answers)
        }
    };

    useEffect(() => {
        const correctAnswersObj = question.correct_answers.map((item) => ({
            key: item.option_key,
            value: item.value
        }));
        setIsCorrectAnswer(correctAnswersObj)
    }, [checkedOptions, label])


    return (
        <Box sx={{ p: 2, border: "1px solid #ddd", borderRadius: 2, mb: 3 }}>
            {/* Question */}
            <Typography variant="h6" gutterBottom>
                {`Q${label}`}. {question?.title}
            </Typography>
            <>
                {question?.options?.map((opt) => {
                    const isCorrectOpt = opt.key === correctAnswerKey;
                    const isUser = opt.key === userAnswerKey;

                    return (
                        <Box
                            key={opt.key}
                            sx={{
                                p: 1.5,
                                borderRadius: 1,
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                                bgcolor: (isAnswered && selectedOptions[question.id] === opt.key)
                                    ? "#e6f4ea" : (!isAnswered && selectedOptions[question.id] === opt.key)
                                        ? '#fdecea' : '#fff',
                                border: (isAnswered && selectedOptions[question.id] === opt.key)
                                    ? '1px solid #4caf50' : (!isAnswered && selectedOptions[question.id] === opt.key)
                                        ? "1px solid red" : "1px solid #ddd"
                            }}
                        >
                            <Typography sx={{ fontWeight: "bold", mr: 1 }}>
                                {opt.key}.
                            </Typography>
                            {console.log("opt>>>>>>", opt)}

                            <input
                                type="checkbox"
                                className="hwCheckbox mr-2"
                                checked={selectedOptions[question.id] === opt.key}
                                onChange={() => handleCheckboxChange(question, opt)}
                            />
                            <Typography sx={{ flexGrow: 1 }}>{opt.value}</Typography>

                            {(selectedOptions[question.id] === opt.key && isAnswered) && (
                                <Typography sx={{ color: "#4caf50", fontWeight: "bold" }}>
                                    ✔ Correct Answer
                                </Typography>
                            )}
                            {(selectedOptions[question.id] === opt.key && !isAnswered) && (
                                <Typography sx={{ color: "#f44336", fontWeight: "bold" }}>
                                    ✘ Wrong Answer
                                </Typography>
                            )}
                            {opt.attachment && (
                                <Box
                                    sx={{
                                        mt: 1,
                                        display: "flex",
                                        gap: 2,
                                        flexWrap: "wrap",
                                        ml: 4,
                                    }}
                                >
                                    <img
                                        src={IP + opt.attachment}
                                        alt={`option-${opt.key}-attachment`}
                                        style={{
                                            maxWidth: "70px",
                                            borderRadius: "6px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                    );
                })}

                {/* Result */}
                <Typography
                    sx={{
                        mt: 2,
                        // color: isCorrect ? "green" : "red",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    {/* {isCorrect ? "✔ Correct" : "✘ Wrong"} */}
                </Typography>

                {showCorrectAnswer && (<Typography sx={{ mt: 1, color: "green" }}>
                    <div>Correct Answer : <span className="font-bold text-lg">{isCorrectAnswer[0]?.key}. {isCorrectAnswer[0]?.value}</span></div>
                    <div>Explanation : <spna className="font-semibold">{question.correct_answers[0]?.reason_for_answer?.explanation ||
                        data.answer?.explanation}</spna></div>
                </Typography>)}

                {/* {teacherComment && (
                    <Box
                        sx={{
                            mt: 1,
                            mb: 1,
                            p: 1.5,
                            borderRadius: 1,
                            bgcolor: "#fffbe6",
                            border: "1px dashed #f0ad4e",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                fontWeight: "bold",
                                fontStyle: "italic",
                                color: "#8a6d3b",
                            }}
                        >
                            Teacher’s Comment
                        </Typography>
                        <Typography sx={{ color: "#5a4632" }}>
                            {teacherComment}
                        </Typography>
                    </Box>
                )} */}
                {/* {
                    allAnswerPopup && <AllAnswerPopup setOpenQuizPopup={setOpenQuizPopup} setAllAnswerPopup={setAllAnswerPopup} libraryQuestions={libraryQuestions} />
                } */}
            </>
        </Box>
    )
}

export default QuestionsList;
